// extracted by mini-css-extract-plugin
module.exports = {"primaryLight":"#71C8E6","mobileBreakpoint":"30rem","form":"style_form__BcTs1","label":"style_label__WjFFX"};